<template>
	<div class="apply-res">
		<div class="echo-area">
			<div class="echo-con">
				<ul>
					<li class="con-left">
						<div class="echo-tit">
							<span>Thank you for your application</span>
							<h3>Application received well</h3>
						</div>
						<div class="echo-btn">
							<router-link to="" @click.native="lookMore">
								<button>Check more position info</button>
							</router-link>
						</div>
					</li>
					<li class="con-right"><img :src="echoImage"/></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
    import echoImage from '@/assets/resource/images/join/image_recruit_12.png';
    export default {

        data(){
            return {
                activeName: 4,
                echoImage: echoImage
            };
        },
        methods: {
            lookMore(){
                const _this = this;
                _this.$emit('go', {
                    type: 'back', val: {
                        activeName: 1,
                        posListheight: '88.5625rem',
                        posConheight: '84.0625rem',
                        listConheight: '74rem',
                    }
                });
            }
        },
        mounted(){
            const _this = this;
        }

    }

</script>

<style scoped>

	.echo-btn button {
		cursor: pointer;
	}

	.apply-res {
		width: 77.5rem;
		height: 40.5rem;
		margin: 0 auto;
	}

	.echo-area {
		clear: both;
		width: 100%;
		height: 38rem;
		background: none;
	}

	/*
	.banner-area{
		height: 0;
	}
	*/
	.echo-area .echo-con {
		width: 100%;
		margin: 0 auto;
	}

	.echo-con > ul {
		width: 100%;
		height: 30.125rem;
		padding-top: 3.9375rem;
	}

	.echo-con > ul > li {
		float: left;
		width: 50%;
		height: 30.125rem;
		/* margin-top: 63px;*/
	}

	.con-left > .echo-tit > span, .con-left > .echo-tit > h3 {
		display: block;
		text-align: left;
		width: 100%;
	}

	.con-left > .echo-tit > span {
		font-size: 1.5rem;
		color: #2A2E2E;
		letter-spacing: 0;
	}

	.con-left > .echo-tit > h3 {
		font-size: 3.5rem;
		color: #2A2E2E;
		letter-spacing: 0;
		margin-top: 1rem;
	}

	.echo-btn button {
		width: 17.6875rem;
		height: 4.5rem;
		background: #F67920;
		font-size: 1.25rem;
		color: #FFFFFF;
		letter-spacing: 0;
		outline: none;
		border: none;
	}

	.con-left .echo-tit {
		text-align: left;
		margin-top: 6.125rem;
	}

	.con-left .echo-btn {
		margin-top: 4rem;
		text-align: left;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/join/join-res.vue